export default "__VITE_ASSET__d7fbba97__"